import React, { useEffect } from 'react';
import { AutocompleteDropdown, OptionKey, usePaginationParams } from '@common-fe/common-fe';

import { useRolePartnersQuery } from '@/modules/role/queries';

interface Props {
  disabled?: boolean;
  value: OptionKey;
  errorText?: string;
  onChangeValue: (value: OptionKey) => void;
}
const RolePartnerPicker: React.FC<Props> = ({disabled, value, onChangeValue, errorText }) => {
  const { setSearchString, currentSearch } = usePaginationParams();

  const { handleSync, options, handleLoadMore, handleReset, isLoading } = useRolePartnersQuery({
    organizationId: value,
    searchString: currentSearch,
    page: 0,
    perPage: 20,
  });

  useEffect(() => {
    handleSync();
    handleReset();
  }, [handleSync, handleReset, currentSearch, value]);

  return (
    <AutocompleteDropdown
      ellipsisMode
      testId="role_partner"
      disabled={disabled}
      onSearch={setSearchString}
      placeholder="Select partner"
      isLoading={isLoading}
      completeValue={`${value}`}
      value={value}
      onChange={onChangeValue}
      handleGetLoadingData={handleLoadMore}
      options={options}
      errorText={errorText}
      id="partner-search"
      name="partner-search"
    />
  );
};

export default RolePartnerPicker;
